import { Stack, Typography } from "@mui/material";
import PercentageIndicator from "./PercentageIndicator";

export default function CtrCell({ ctr }) {
  if (!ctr) return "-";
  return (
    <Stack
      direction="column"
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100%" }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: "#00000099", fontSize: "14px" }}
        >
          {ctr?.value?.toFixed(2)}%
        </Typography>
      </Stack>
      <PercentageIndicator value={ctr?.change} />
    </Stack>
  );
}
